import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.875 19.3001L4.275 12.7001C4.175 12.6001 4.104 12.4917 4.062 12.3751C4.02067 12.2584 4 12.1334 4 12.0001C4 11.8667 4.02067 11.7417 4.062 11.6251C4.104 11.5084 4.175 11.4001 4.275 11.3001L10.875 4.70008C11.0583 4.51675 11.2873 4.42075 11.562 4.41208C11.8373 4.40408 12.075 4.50008 12.275 4.70008C12.475 4.88342 12.5793 5.11242 12.588 5.38708C12.596 5.66242 12.5 5.90008 12.3 6.10008L7.4 11.0001H18.575C18.8583 11.0001 19.096 11.0957 19.288 11.2871C19.4793 11.4791 19.575 11.7167 19.575 12.0001C19.575 12.2834 19.4793 12.5207 19.288 12.7121C19.096 12.9041 18.8583 13.0001 18.575 13.0001H7.4L12.3 17.9001C12.4833 18.0834 12.5793 18.3167 12.588 18.6001C12.596 18.8834 12.5 19.1167 12.3 19.3001C12.1167 19.5001 11.8833 19.6001 11.6 19.6001C11.3167 19.6001 11.075 19.5001 10.875 19.3001Z",
		fill: "currentColor"
	})
});
export default SvgArrowLeft;
